import { Component } from "@angular/core";
import { ProgramsListingComponent } from "./components/programs-listing/programs-listing.component";

@Component({
  selector: "jni-programs",
  templateUrl: "./programs.component.html",
  styleUrls: ["./programs.component.scss"],
  imports: [ProgramsListingComponent],
})
export class ProgramsComponent {}
